// extracted by mini-css-extract-plugin
module.exports = {"default_card":"DefaultBio_default_card__uLqyv","default_card__bioText":"DefaultBio_default_card__bioText__s_3Y6","default_card__button":"DefaultBio_default_card__button__bL6JC"};